// icon:bx-book-heart | Boxicons https://boxicons.com/ | Atisa
import * as React from "react";
import Icon from "../../images/art/icons/Preachers.png";

function IconBxBookHeart(props) {
	return (
		<img src={Icon} style={{ height: '1em', width: '1em', ...props }} alt={"Preachers"} />
	)
}

export default IconBxBookHeart;
